import gql from 'graphql-tag'

export const SUBSCRIBE_GALLERY_IMAGE = gql`
subscription {
 gallery (order_by: {sequenceNo: asc}){
    id
    imageUrl
    redirectUrl
    caption
    sequenceNo
    isActive
    created_at
    updated_at
    }
  }
 `
